<template>
  <!-- Desktop Starts -->
  <v-row>
    <v-col cols="12" class="px-0 py-6 text-center">
      <Achievement />
    </v-col>
    <v-col cols="12" class="px-0 text-center">
      <ProgressCircle :progress="getProgressProp > 100 ? 100 : getProgressProp" :size="13" />
    </v-col>
    <v-col v-if="includeSpouseProp" cols="12" class="px-0 mt-4">
      <v-tabs
        id="you_spouse_tabs"
        grow
        v-model="selectedTab"
        color="primary"
        slider-color="#cecece"
      >
        <v-tab color="black" @click="updateSelectedTabTop(0)">
          {{ $t('L_you') }}
        </v-tab>
        <v-tab color="black" @click="updateSelectedTabTop(1)">
          {{ $t('L_spouse') }}
        </v-tab>
      </v-tabs>
    </v-col>
    <!-- You have in protection -->
    <v-col cols="12" class="px-0">
      <GuidancePill
        :header="selectedTab === 0 ? $t('L_pill_you_have') : $t('L_pill_spouse_has')"
        :amount="``"
        :footer="$t('L_pill_in_protection')"
      >
        <span style="font-size: 1.2em">{{ formattedCurrentCoverageProp }}*</span>
      </GuidancePill>
    </v-col>
    <!-- You need in life insurance -->
    <v-col cols="12" class="px-0 mt-4">
      <GuidancePill
        :header="selectedTab === 0 ? $t('L_pill_you_need') : $t('L_pill_spouse_needs')"
        :amount="formattedNeedProp"
        :footer="$t('L_pill_in_life_insurance')"
      />
    </v-col>
    <!-- How did we calculate -->
    <v-col cols="12">
      <h4 class="text-h4 text-center mb-4" role="presentation">
        <OnexButton
          @click="dialog = true"
          :text="$t('L_how_did_we_calculate')"
          variant="text"
          color="anchor"
          class="px-0"
        ></OnexButton>
      </h4>
    </v-col>
    <v-col class="bg-grey-lighten-2 px-4 py-2">
      <v-row v-if="additionalNeedProp > 0" class="mb-3 pt-4">
        <v-col cols="12" class="text-center">
          <v-row justify="center">
            <v-img
              src="@/modules/policy/PolicyGuidanceCalculator/assets/md-recommend.svg"
              :alt="$t('L_recommended_additional_coverage')"
              height="70px"
              max-width="70px"
            />
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-3">
          <GuidancePill
            :header="$t('L_we_recommend_adding')"
            :amount="formattedAdditionalProp"
            :footer="$t('L_in_life_coverage')"
          />
        </v-col>
        <v-col cols="12" class="pt-4 text-center">
          <h3 v-html="$t('L_increase_coverage_today')" class="heading_three font-weight-bold" />
        </v-col>
      </v-row>
    </v-col>
    <!-- Desktop Dialog -->
    <v-dialog v-model="dialog" max-width="400" :fullscreen="$vuetify.display.xs">
      <v-card class="how_did_we_calculate_modal">
        <v-card-text class="font-weight-regular how_did_we_calculate_content">
          <div v-html="$t('L_how_did_we_calculate_text')" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <OnexButton
            class="bg-primary-lighten-2 how_did_we_calculate_close"
            @click="dialog = false"
          >
            Got It
          </OnexButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Achievement from '@/components/Achievement/Achievement.vue';
import ProgressCircle from '@/components/ProgressCircle/ProgressCircle.vue';
import GuidancePill from './GuidancePill.vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'SidebarDesktop',
  components: {
    GuidancePill,
    Achievement,
    ProgressCircle,
    OnexButton,
  },
  props: {
    includeSpouseProp: {
      type: Boolean,
      required: true,
      default: false,
    },
    getProgressProp: {
      type: Number,
      required: true,
      default: null,
    },
    formattedCurrentCoverageProp: {
      type: String,
      required: true,
      default: '',
    },
    formattedNeedProp: {
      type: String,
      required: true,
      default: '',
    },
    additionalNeedProp: {
      type: [Number, String],
      required: true,
      default: null,
    },
    formattedAdditionalProp: {
      type: [Number, String],
      required: true,
      default: null,
    },
    displayContactRep: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    updateSelectedTabTop(value: number) {
      this.$emit('updateSelectedTab', value);
    },
  },
  data: () => ({
    padding: 0,
    selectedTab: 0,
    dialog: false,
    contactMe: false,
  }),
  watch: {
    includeSpouseProp(newData) {
      if (newData === false) {
        this.updateSelectedTabTop(0);
        this.selectedTab = 0;
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
:deep(.v-btn--variant-text .v-btn__content) {
  white-space: normal;
}
</style>
